import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import {
	PageFeatureConfigSymbol,
	IPageWillMountHandler,
	IPropsStore,
	Props,
	SiteFeatureConfigSymbol,
	pageIdSym,
	PageScrollRegistrarSymbol,
	Experiments,
	ExperimentsSymbol,
	PlatformSymbol,
	IPlatform,
} from '@wix/thunderbolt-symbols'
import { SiteScrollBlockerSymbol, ISiteScrollBlocker } from 'feature-site-scroll-blocker'
import { IPageScrollRegistrar } from 'feature-page-scroll'
import { name } from './symbols'
import { OOIPageConfig, OOISiteConfig } from './types'
import { createHostProps } from './hostProps'
import { OoiTpaSharedConfigSymbol, IOoiTpaSharedConfig } from 'feature-ooi-tpa-shared-config'

export default withDependencies(
	[
		pageIdSym,
		named(PageFeatureConfigSymbol, name),
		named(SiteFeatureConfigSymbol, name),
		Props,
		SiteScrollBlockerSymbol,
		PageScrollRegistrarSymbol,
		OoiTpaSharedConfigSymbol,
		ExperimentsSymbol,
		optional(PlatformSymbol),
	],
	(
		pageId,
		{ ooiComponents, accessibilityEnabled }: OOIPageConfig,
		{ viewMode, formFactor }: OOISiteConfig,
		propsStore: IPropsStore,
		siteScrollBlocker: ISiteScrollBlocker,
		{ registerToThrottledScroll }: IPageScrollRegistrar,
		{ getFontsConfig }: IOoiTpaSharedConfig,
		experiments: Experiments,
		platform?: IPlatform
	): IPageWillMountHandler => {
		return {
			pageWillMount() {
				ooiComponents.forEach((compData) => {
					const hostProps = createHostProps({
						compData,
						pageId,
						accessibilityEnabled,
						formFactor,
						viewMode,
						siteScrollBlocker,
						registerToThrottledScroll,
						fonts: getFontsConfig(),
						experiments,
						platform,
					})

					propsStore.update({
						[compData.compId]: {
							host: hostProps,
						},
					})
				})
			},
		}
	}
)
